import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { ParentPain } from './components/ParentPain';
import { Reframe } from './components/Reframe';
import { ToolkitIntro } from './components/ToolkitIntro';
import { LookInside } from './components/LookInside';
import { WhatsIncluded } from './components/WhatsIncluded';
import { ParentFeedback } from './components/ParentFeedback';
import { OfferStack } from './components/OfferStack';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
type AppProps = {
  /** Turn on once real interior page screenshots are added to previewSlots in data/content.ts. */
  showLookInside?: boolean;
};
export function App({
  showLookInside = false
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="23ti7s3go4sjo">
      <noscript data-id="element-1" data-mp="3ij64a9st9l7v">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3ijpbavgxap74" />
      </noscript>
      <SiteHeader data-id="element-3" data-mp="3relw6la09qat" />
      <main data-id="element-4" data-mp="5os92t1uy7l">
        <Hero data-id="element-5" data-mp="67yhm9c7y5s" />
        <ParentPain data-id="element-6" data-mp="4wylxj0jajy" />
        <Reframe data-id="element-7" data-mp="56mnfkhz7n0" />
        <ToolkitIntro data-id="element-8" data-mp="7suzhf7pr6a" />
        {showLookInside && <LookInside data-id="element-9" data-mp="2zlv8x0aavbxp" />}
        <WhatsIncluded data-id="element-10" data-mp="2zmo4r67q0h12" />
        <ParentFeedback data-id="element-11" data-mp="2zn6cayzu2hoa" />
        <OfferStack data-id="element-12" data-mp="33mf2jtvnzxf3" />
        <Faq data-id="element-13" data-mp="33lx02fiesmyq" />
        <FinalClose data-id="element-14" data-mp="33ngdzzglelxc" />
      </main>
      <Footer data-id="element-15" data-mp="33ork45xig5rm" />
    </div>;
}